import { Offcanvas, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ReactPaginate from "react-paginate";
import moment from "moment";
import {
  customerCategoryService,
  FetchShopScrollersService,
  kansas_productListService,
} from "../../../Services/ApiServices";
import Styles from "./AllProducts.module.css";
import search from "../../../Assets/search.svg";
import { TabTitle } from "../../../Utility/TabTitle";
import notFoundImage from "../../../Assets/productNotFound.svg";
import Loader from "../../../SharedComponents/Loader/Loader";
import Checkbox from "../Products/CheckBox";
import ProductItem from "../Products/ProductItem";
import CategoryDropdown from "../Products/DropDown";
import Header from "../../../SharedComponents/Header/Header";
import LeftArrow from "../../../Assets/modal_left_arrow.png";
import RightArrow from "../../../Assets/modal_right_arrow.png";
import cart from "../../../Assets/shopping-cart.png";
import ProductsAttributesContainer from "./ProductsAttributesContainer";
import MarqueeText from "../../Marquee/MarqueeText";
import ViewSettingsImage from "../../../Modal/ViewSettingsImage";
import { useSelector } from "react-redux";
import VaniGoLogo from "../../../Assets/vanigo_logo.png";
import SupportAgent from "../../../Assets/support_agent_black.png";
import SupportContactModal from "../../../Modal/SupportContactModal";
import SuggestionBox from "../../../Modal/SuggestionBox";
import BarcodeScannerModal from "../../../Modal/BarcodeScannerModal.tsx";
import ManualProductEntryModal from "../../../Modal/ManualProductEntryModal";
import barcodeScannerIcon from "../../../Assets/barcode_scanner_black.svg";
import plusIcon from "../../../Assets/add.png";
import shopClosedImage from "../../../Assets/shop_closed.png";
import ViewCustomerProduct from "./ViewCustomerProduct.js";

const PRODUCTS_PER_PAGE = 30;

export default function AllProducts() {
  TabTitle("KSTORE - Products");
  let navigate = useNavigate();
  let { state, pathname } = useLocation();
  const logoDetails = useSelector((state) => state.logo_details);
  let franchise_id = JSON.parse(sessionStorage.getItem("customerlog"));
  const franchiseMobile = sessionStorage.getItem("franchise_mobile");
  const [categoryName, setCategoryName] = useState("");
  const [id, setId] = useState(1);
  const [show, setShow] = useState(false);
  const [showSupportListModal, setshowSupportListModal] = useState(false);
  const [productDetails, setProductDetails] = useState(null);
  const [filterDetails, setFilterDetails] = useState([]);
  const [productSearch, setProductSearch] = useState("");
  const [filter, setFilter] = useState("");
  const [brandData, setBrandData] = useState([]);
  const [customerSelectedItem, setcustomerSelectedItem] = useState([]);
  const [filterBrandData, setFilterBrandData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [selectedProductsAttributes, setselectedProductsAttributes] = useState(
    [],
  );

  const [showSuggestionModal, setShowSuggestionModal] = useState(false);
  const [showManualProductModal, setShowManualProductModal] = useState(false);
  const [isOpenBarcodeScanner, setisOpenBarcodeScanner] = useState(false);
  const [scannedProductData, setScannedProductData] = useState(null);

  const [filterIds, setFilterIds] = useState({ sub_id: "", cat_id: "" });
  const [productsAttributes, setproductsAttributes] = useState([]);
  const handleClose = () => setShow(false);
  const [ShopScrollers, setShopScrollers] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const alreadyShown = sessionStorage.getItem("popupShown");

  useEffect(() => {
    handleGetCategoryList();
    getShopScrollers();
  }, []);

  useEffect(() => {
    handleGetProduct(filterIds.sub_id, filterIds.cat_id);
  }, [filter]);

  useEffect(() => {
    const sessionLocation = sessionStorage.getItem("location_details");
    if (sessionLocation === null) {
      getLocation();
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem("customer_cart_list")) {
      setcustomerSelectedItem(
        JSON.parse(sessionStorage.getItem("customer_cart_list")),
      );
    }
  }, []);

  // for location access
  const getLocation = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      sessionStorage.setItem(
        "location_details",
        JSON.stringify({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        }),
      );
    });
  };

  const handleGetCategoryList = () => {
    let formData = new FormData();
    formData.append("franchise_code", franchise_id?.id);
    customerCategoryService(formData)
      .then((res) => setFilterDetails(res.data.items))
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg);
        } else {
          toast.error("Something went wrong!!");
        }
      });
  };

  const handleGetProduct = (
    sub_category_id = "",
    category_id = "",
    category_name = "",
    page = 1,
  ) => {
    setIsLoader(true);
    setFilterIds({ sub_id: sub_category_id, cat_id: category_id });
    setCategoryName(category_name);
    let formData = new FormData();
    formData.append("franchise_id", franchise_id?.id);
    formData.append("product_name", productSearch);
    // formData.append("list_type", state !== null ? parseInt(state) : 2);
    if (category_id && sub_category_id) {
      formData.append("sub_category_id", parseInt(sub_category_id));
      formData.append("category_id", parseInt(category_id));
    } else if (category_id) {
      formData.append("category_id", parseInt(category_id));
    }
    if (filterBrandData.length !== 0) {
      formData.append("brand", "[" + filterBrandData + "]");
    }
    if (selectedProductsAttributes.length > 0) {
      formData.append("product_attribute_value_id", selectedProductsAttributes);
    }

    if (filter !== "") {
      let splitData = filter.split("-");
      if (splitData[1] === "1") {
        formData.append("order_by", "product_name");
        formData.append("order", splitData[0]);
        formData.append("sub_category_id", filterIds?.sub_id);
        formData.append("category_id", filterIds?.cat_id);
      }
      if (splitData[1] === "2") {
        formData.append("order_by", "selling_price");
        formData.append("order", splitData[0]);
      }
    }
    kansas_productListService(formData, page, PRODUCTS_PER_PAGE)
      .then((res) => {
        setBrandData(res.data.brands);
        setproductsAttributes(res.data.product_attribute);
        setProductDetails(res.data);
        if (category_id && sub_category_id) {
          handleClose();
        }
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  console.log(productDetails, "productDetails");

  const hanldeBrandData = (brandID) => {
    if (filterBrandData.includes(brandID)) {
      setFilterBrandData(filterBrandData.filter((e) => e !== brandID));
    } else {
      setFilterBrandData([...filterBrandData, brandID]);
    }
  };

  const handleSelectedData = (data) => {
    let isAlreadyExist = customerSelectedItem?.find(
      (e) =>
        e?.product_id === data?.product_id &&
        e.selectedUnit?.unit_id === data?.selectedUnit?.unit_id,
    )
      ? true
      : false;

    console.log(isAlreadyExist, data, "customerSelectedItem");

    // if (!isAlreadyExist) {
    console.log(
      customerSelectedItem,
      data,
      customerSelectedItem.findIndex((e) => {
        console.log(e, data, "daya");
        return e.product_id === data.product_id;
      }),
      "findind",
    );

    if (isAlreadyExist) {
      // console.log(
      //   customerSelectedItem.findIndex((e) => {
      //     console.log(e, data);

      //     return e.product_id === data.product_id;
      //   }),
      //   "minusone="
      // );

      let filterData = [...customerSelectedItem].filter((e) => {
        console.log(e, data, "minusone=");

        return e.product_id === data.product_id
          ? e.selectedUnit?.unit_id !== data?.selectedUnit?.unit_id
          : e.product_id !== data.product_id;
      });
      setcustomerSelectedItem(filterData);
    } else {
      console.log("minusone==");

      setcustomerSelectedItem((pre) => [
        ...pre,
        {
          ...data,
          qty: data?.qty,
          total_amount: data?.selling_price * data?.qty,
          selectedUnit: data?.selectedUnit
            ? {
                ...data?.selectedUnit,
                total_amount:
                  data?.selectedUnit?.selling_price * data?.selectedUnit?.qty,
              }
            : undefined,
        },
      ]);
    }
    // }
  };

  const handleAddManualProduct = (productData) => {
    const manualItem = {
      product_id: Date.now(),
      product_name: productData.product_name,
      brand_name: productData.brand_name || "",
      qty: Number(productData.qty) || 1,
      unit: productData.unit || "",
      selling_price: 0,
      total_amount: 0,
      min_quantity: 1,
      max_quantity: 9999,
      product_images: [],
      product_unit: [],
      selectedUnit: productData.unit
        ? {
            id: Date.now(),
            unit_id: productData.unit,
            qty: Number(productData.qty) || 1,
            selling_price: 0,
            total_amount: 0,
            min_quantity: 1,
            quantity: 9999,
          }
        : undefined,
      is_manual: true,
      customer_wishlist_id: `manual_${Date.now()}`,
    };

    const updatedCart = [...customerSelectedItem, manualItem];
    setcustomerSelectedItem(updatedCart);
    sessionStorage.setItem(
      "customer_cart_list",
      JSON.stringify(updatedCart),
    );
    toast.success("Product added to cart successfully");
    setShowManualProductModal(false);
  };

  const handleAllproductId = (val) => {
    setId(0);
  };

  const handleProductsAttributesChecked = (id, isChecked) => {
    let tempAttributesIds = [...selectedProductsAttributes];
    if (isChecked) {
      tempAttributesIds.push(id);
    } else {
      tempAttributesIds = tempAttributesIds.filter((itemId) => itemId !== id);
    }
    setselectedProductsAttributes(tempAttributesIds);
  };

  const handleClearFilter = (page = 1) => {
    setIsLoader(true);
    setProductSearch("");
    setFilterBrandData([]);
    setFilter("");
    setselectedProductsAttributes([]);
    let formData = new FormData();
    formData.append("franchise_id", franchise_id?.id);
    // formData.append("list_type", state !== null ? parseInt(state) : 2);
    kansas_productListService(formData, page, PRODUCTS_PER_PAGE)
      .then((res) => setProductDetails(res.data))
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  useEffect(() => {
    sessionStorage.setItem("isproduct", state?.isproduct);
  }, []);

  // useEffect(() => {
  //   // Push a new history state to prevent going back
  //   window.history.pushState(null, document.title, window.location.href);

  //   const handlePopState = (e) => {
  //     // When the user tries to go back, we push a new state to keep them on the current page
  //     window.history.pushState(null, document.title, window.location.href);
  //   };

  //   // Listen for popstate event (triggered by back button or history navigation)
  //   window.addEventListener("popstate", handlePopState);

  //   return () => {
  //     // Cleanup event listener when the component unmounts
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, []);

  const getShopScrollers = () => {
    setIsLoader(true);
    let formData = new FormData();

    formData.append("franchise_code", franchise_id?.id);

    FetchShopScrollersService(formData)
      .then((res) => {
        setShopScrollers(res?.data?.data);
        sessionStorage.setItem(
          "shop_scrollers",
          JSON.stringify({ ...res.data.data }),
        );
        if (!alreadyShown) {
          setShowPopup(true);
          sessionStorage.setItem("popupShown", true);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  const isShopClosed =
    pathname.includes("/kansas_product") && ShopScrollers?.is_open === 2;

  return (
    <>
      <div className={Styles.bannerWrapper}>
        <div
          className={Styles.banner}
          style={{
            backgroundImage: logoDetails?.banner_image
              ? `url(${logoDetails?.banner_image})`
              : "none",
          }}
        ></div>

        <div className={Styles.logoWrapper}>
          <img
            src={logoDetails?.logo ? logoDetails.logo : VaniGoLogo}
            onClick={() => {
              if (pathname.includes("/kansas_product")) {
                navigate("/kansas_product/allproducts");
              } else {
                navigate("/store");
              }
            }}
            alt="logo"
            className={Styles.hangingLogo}
          />
        </div>
        <div className={`${Styles.LogoImgContainer}`}>
          {pathname.includes("/kansas_product") &&
            !isShopClosed &&
            ShopScrollers?.is_barcode_enabled === 1 && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Barcode</Tooltip>}
              >
                <div style={{ marginRight: "10px" }}>
                  <div>
                    <img
                      width="25px"
                      src={barcodeScannerIcon}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setisOpenBarcodeScanner(true);
                      }}
                    />
                  </div>
                </div>
              </OverlayTrigger>
            )}

          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Support</Tooltip>}
          >
            <div style={{ marginRight: "10px" }}>
              <div>
                <img
                  onClick={() => setshowSupportListModal((pre) => !pre)}
                  className={Styles.notificationIcon}
                  src={SupportAgent}
                  alt="Support"
                  color="black"
                />
              </div>
            </div>
          </OverlayTrigger>
        </div>
      </div>
      {ShopScrollers?.text ? (
        <MarqueeText data={ShopScrollers} />
      ) : (
        <div style={{ marginTop: "50px" }} />
      )}
      {ShopScrollers?.image && showPopup ? (
        <ViewSettingsImage
          data={ShopScrollers}
          showPopup={showPopup}
          onClose={() => {
            setShowPopup(false);
          }}
        />
      ) : null}
      {isShopClosed && (
        <div className={Styles.shopClosedBanner}>
          <p className={Styles.shopClosedTitle}>🧡 We Missed You!</p>
          <img
            className={Styles.shopClosedIcon}
            src={shopClosedImage}
            alt="Shop closed"
          />
          {ShopScrollers?.today_special_holiday?.reason && (
            <p className={Styles.shopClosedText}>
              Reason:{" "}
              <span className={Styles.shopClosedHighlight}>
                {ShopScrollers.today_special_holiday.reason}
              </span>
            </p>
          )}
          {ShopScrollers?.next_working_day && (
            <p className={Styles.shopClosedText}>
              <span className={Styles.shopClosedBackOnText}>
                We&apos;ll be back on
              </span>
              <br />
              <span className={Styles.shopClosedDateTime}>
                {moment(ShopScrollers.next_working_day.date, "DD-MM-YY").format(
                  "DD MMM YYYY",
                )}
              </span>{" "}
              <span className={Styles.shopClosedBackOnText}>at</span>{" "}
              <span className={Styles.shopClosedDateTime}>
                {moment(
                  ShopScrollers.next_working_day.open_time,
                  "HH:mm:ss",
                ).format("hh:mm A")}
              </span>
            </p>
          )}
        </div>
      )}
      {!isShopClosed && (
        <div className={Styles.overallContainer}>
          <Loader isLoader={isLoader} />
          <div className={Styles.mblFilter}>
            <Offcanvas placement="bottom h-75" show={show} onHide={handleClose}>
              <Offcanvas.Header className={Styles.filterHeading}>
                {/* <Offcanvas.Title className="w-100">
                <div className="d-flex align-items-center">
                  <div
                    className={
                      Styles.searchChildContainer + " flex-grow-1 mb-0"
                    }
                  >
                    <input
                      className={Styles.searchInput + " label"}
                      type="text"
                      value={productSearch}
                      placeholder="Search Products..."
                      onChange={(e) => setProductSearch(e.target.value)}
                    />
                    <div className="align-self-center">
                      <img
                        className={Styles.searchImg}
                        onClick={() => {
                          try {
                            handleGetProduct(
                              filterIds.sub_id,
                              filterIds.cat_id,
                            );
                            handleClose();
                          } catch (error) {}
                        }}
                        src={search}
                        alt="search"
                      />
                    </div>
                  </div>
                  <button
                    className="border-0 text-white ms-2 d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "#FF7C25",
                      borderRadius: "50%",
                      width: "46px",
                      height: "46px",
                      flexShrink: 0,
                    }}
                    onClick={() => {
                      setShowSuggestionModal(true);
                      handleClose();
                    }}
                    title="Suggest a Product"
                  >
                    <i className="fa-solid fa-lightbulb"></i>
                  </button>
                </div>
              </Offcanvas.Title> */}
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className={Styles.tabLeftContainer}>
                  <div>
                    <div className="d-flex justify-content-between">
                      <h4 className="fontBold">Categories</h4>
                    </div>
                  </div>
                  <div className="d-flex">
                    <hr className={Styles.hr1} />
                    <hr className={Styles.hr2} />
                  </div>

                  <div className={Styles.overall}>
                    <p
                      className={Styles.heading + " dropdownHeading"}
                      onClick={() => {
                        setFilter("");
                        setProductSearch("");
                        handleGetProduct();
                        setId(1);
                      }}
                      style={{
                        color: parseInt(id) === 1 ? "#FF7C25" : "black",
                      }}
                    >
                      All Produts
                    </p>
                    {filterDetails?.map((e) => (
                      <CategoryDropdown
                        key={e.category_id}
                        data={e}
                        handleAllproductId={handleAllproductId}
                        categoryID={filterIds}
                        handleGetProduct={(sub_id, cat_id, cat_name) => {
                          setFilter("");
                          setProductSearch("");
                          handleGetProduct(sub_id, cat_id, cat_name);
                        }}
                      />
                    ))}
                  </div>
                  <div>
                    <div className="d-flex justify-content-between mt-4">
                      <h4 className="fontBold">Brand</h4>
                      <span
                        onClick={() => {
                          setFilter("");
                          setProductSearch("");
                          handleGetProduct(filterIds.sub_id, filterIds.cat_id);
                          handleClose();
                        }}
                        className={Styles.applyBtn}
                      >
                        Apply
                      </span>
                    </div>
                  </div>
                  <div className="d-flex">
                    <hr
                      style={{
                        display: brandData.length === 0 ? "none" : null,
                      }}
                      className={Styles.hr1}
                    />
                    <hr
                      style={{
                        display: brandData.length === 0 ? "none" : null,
                      }}
                      className={Styles.hr2}
                    />
                  </div>

                  <div>
                    <Checkbox
                      hanldeBrandData={hanldeBrandData}
                      checkboxData={brandData}
                      filterData={filterBrandData}
                    />
                  </div>

                  <ProductsAttributesContainer
                    productsAttributes={productsAttributes}
                    onPressSeachButton={() => {
                      setFilter("");
                      setProductSearch("");
                      handleGetProduct(filterIds.sub_id, filterIds.cat_id);
                      handleClose();
                    }}
                    handleProductAttributeChecked={
                      handleProductsAttributesChecked
                    }
                    selectedProductsAttributes={selectedProductsAttributes}
                  />
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
          <div className={Styles.leftContainer}>
            <div>
              <div className="d-flex justify-content-between">
                <h4 className="fontBold">Categories</h4>
              </div>
            </div>
            <div className="d-flex">
              <hr className={Styles.hr1 + " m-0"} />
              <hr className={Styles.hr2 + " m-0"} />
            </div>
            <div className={Styles.overall}>
              <p
                className={Styles.heading + " dropdownHeading"}
                onClick={() => {
                  setFilter("");
                  setProductSearch("");
                  handleGetProduct();
                  setId(1);
                }}
                style={{
                  color: parseInt(id) === 1 ? "#FF7C25" : "black",
                }}
              >
                All Products
              </p>
              {filterDetails?.map((e) => (
                <CategoryDropdown
                  key={e.category_id}
                  data={e}
                  handleAllproductId={handleAllproductId}
                  categoryID={filterIds}
                  handleGetProduct={(sub_id, cat_id, cat_name) => {
                    setFilter("");
                    setProductSearch("");
                    handleGetProduct(sub_id, cat_id, cat_name);
                  }}
                />
              ))}
            </div>
            <div>
              <div className="d-flex justify-content-between">
                <h4 className="fontBold">Brand</h4>
                <span
                  onClick={() =>
                    handleGetProduct(filterIds.sub_id, filterIds.cat_id)
                  }
                  className={Styles.applyBtn}
                >
                  Apply
                </span>
              </div>
            </div>
            <div className="d-flex">
              <hr
                style={{
                  display: brandData.length === 0 ? "none" : null,
                }}
                className={Styles.hr1 + " m-0"}
              />
              <hr
                style={{
                  display: brandData.length === 0 ? "none" : null,
                }}
                className={Styles.hr2 + " m-0"}
              />
            </div>
            {filterIds.cat_id !== "" || brandData.length !== 0 ? (
              <div>
                <Checkbox
                  hanldeBrandData={hanldeBrandData}
                  checkboxData={brandData}
                  filterData={filterBrandData}
                />
              </div>
            ) : null}
            <ProductsAttributesContainer
              productsAttributes={productsAttributes}
              onPressSeachButton={() => {
                handleGetProduct(filterIds.sub_id, filterIds.cat_id);
              }}
              handleProductAttributeChecked={handleProductsAttributesChecked}
              selectedProductsAttributes={selectedProductsAttributes}
            />
          </div>
          <div
            style={{
              height: productDetails?.items?.length === 0 ? "80vh" : "unset",
            }}
            className={
              Styles.rightContainer +
              (productDetails?.items?.length === 0 ? " d-flex flex-column" : "")
            }
          >
            <div
              className={
                Styles.rightFilterContainer +
                " d-flex flex-wrap align-items-center justify-content-between"
              }
            >
              <div
                className="d-flex align-items-center flex-grow-1 mb-3 me-md-3"
                style={{ maxWidth: "450px" }}
              >
                <div
                  className={Styles.searchChildContainer + " flex-grow-1 mb-0"}
                >
                  <input
                    className={Styles.searchInput + " kstoreFont"}
                    type="text"
                    value={productSearch}
                    placeholder="Search Products..."
                    onChange={(e) => setProductSearch(e.target.value)}
                  />
                  <div className="align-self-center">
                    <img
                      className={Styles.searchImg}
                      onClick={() =>
                        handleGetProduct(filterIds.sub_id, filterIds.cat_id)
                      }
                      src={search}
                      alt="search"
                    />
                  </div>
                </div>

                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Add Product Manually</Tooltip>}
                >
                  <button
                    type="button"
                    className={Styles.addManualBtn}
                    onClick={() => setShowManualProductModal(true)}
                  >
                    <img
                      src={plusIcon}
                      alt="Add Product"
                      className={Styles.addManualIcon}
                    />
                  </button>
                </OverlayTrigger>
              </div>
              <div className={Styles.mblFilterContainer}>
                <div
                  className={
                    Styles.filter +
                    " d-flex align-items-center justify-content-center d-lg-none"
                  }
                  style={{ height: "45px", cursor: "pointer" }}
                  onClick={() => setShow(true)}
                >
                  <span className={Styles.filterText + " contentFont"}>
                    Filter
                  </span>
                </div>
                <div className={Styles.clearFilterContainer}>
                  {/* {productSearch !== "" ||
                filterBrandData.length > 0 ||
                selectedProductsAttributes.length > 0 ||
                filter !== "" ? (
                  <p
                    onClick={() => handleClearFilter(1)}
                    className={Styles.clearfilterText}
                  >
                    Clear Filter
                  </p>
                ) : null} */}
                  <div className={Styles.sortText}>
                    <div className={Styles.selectContainer}>
                      <select
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        className={`${Styles.empty} ${filter === "" ? Styles.sortByActive : ""} kstoreFont2`}
                      >
                        <option value="">Sort By</option>
                        <option value="asc-1">Name (A to Z)</option>
                        <option value="desc-1">Name (Z to A)</option>
                        <option value="desc-2">Price (High to Low)</option>
                        <option value="asc-2">Price (Low to High)</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {productDetails && productDetails?.items?.length === 0 ? (
              <div className={`${Styles.notFoundImgContainer} w-100`}>
                {/* The Visual Image */}
                <img
                  className={Styles.notFoundImg}
                  src={notFoundImage}
                  style={
                    pathname.includes("/kansas_product")
                      ? { width: "150px" }
                      : { width: "220px" }
                  }
                  alt="notfound"
                />

                {pathname.includes("/kansas_product") ? (
                  <div className="d-flex flex-column align-items-center animate__animated animate__fadeIn">
                    {/* Subtext explanation */}
                    <p className={Styles.subText}>
                      We couldn't find what you're looking for. <br />
                      Want us to get it for you?
                    </p>

                    {/* Action Button */}
                    <button
                      className={`${Styles.suggestBtn} kstoreFont`}
                      onClick={() => setShowSuggestionModal(true)}
                      title="Suggest Product"
                    >
                      <span className={Styles.plusIcon}>+</span>
                      <span>You Ask. We Stock.</span>
                    </button>

                    {/* Secondary Action */}
                    <button
                      className={Styles.backBtn}
                      onClick={() => window.history.back()}
                    >
                      <span>←</span> Back to Shopping
                    </button>
                  </div>
                ) : (
                  <div className="text-muted mt-2">
                    No results found for your search.
                  </div>
                )}
              </div>
            ) : (
              <div className={Styles.mblProducts + " row"}>
                {productDetails?.items?.map((e) => (
                  <ProductItem
                    categoryname={categoryName}
                    data={e}
                    key={e.product_id}
                    customer="1"
                    handleSelectedData={handleSelectedData}
                    customerSelectedItem={customerSelectedItem.map(
                      (e) => e.product_id,
                    )}
                    productType={state !== null ? parseInt(state) : 2}
                    customerSelectedProducts={customerSelectedItem}
                  />
                ))}
              </div>
            )}

            {productDetails && productDetails?.items?.length > 0 && (
              <div
                className={Styles.mblcart}
                onClick={() => {
                  navigate("/kansas_product/customercartlist", {
                    state: {
                      selectedItems: customerSelectedItem,
                      minimumOrderValue: productDetails?.minimum_order_value,
                    },
                  });
                  sessionStorage.setItem(
                    "customer_cart_list",
                    JSON.stringify(customerSelectedItem),
                  );
                }}
              >
                <img className={Styles.cartImg} src={cart} alt="cart" />
                <div className={Styles.notification}>
                  <span className={Styles.badge}>
                    {customerSelectedItem?.length}
                  </span>
                </div>
              </div>
            )}
            <div
              style={{
                display:
                  productDetails?.total <= PRODUCTS_PER_PAGE ? "none" : "flex",
              }}
              className={Styles.paginationContainer}
            >
              <ReactPaginate
                previousLabel={<img src={LeftArrow} alt="left" />}
                nextLabel={<img src={RightArrow} alt="right" />}
                breakLabel="..."
                pageCount={Math.ceil(productDetails?.total) / PRODUCTS_PER_PAGE}
                marginPagesDisplayed={1}
                pageRangeDisplayed={1}
                onPageChange={({ selected }) =>
                  handleGetProduct(
                    filterIds?.sub_id,
                    filterIds?.cat_id,
                    "",
                    selected + 1,
                  )
                }
                containerClassName={
                  "pagination m-0 d-flex justify-content-end me-4 bg-secondory"
                }
                pageClassName={"page-item"}
                pageLinkClassName={
                  "page-link text-secondary rounded-circle bg-light pt-1 pb-1 ps-2 pe-2 ms-1 me-1 border-0 shadow-none"
                }
                forcePage={""}
                previousClassName={"page-item"}
                previousLinkClassName={
                  "page-link border-0 text-dark p-1 rounded-circle bg_orange shadow-none me-1"
                }
                nextClassName={"page-item "}
                nextLinkClassName={
                  "page-link border-0 text-dark p-1 bg_orange rounded-circle shadow-none ms-1"
                }
                activeClassName={"active"}
              />
            </div>
          </div>
        </div>
      )}
      {showSupportListModal && (
        <SupportContactModal
          show={showSupportListModal}
          onClose={() => setshowSupportListModal(false)}
          phone={franchiseMobile}
        />
      )}

      <SuggestionBox
        show={showSuggestionModal}
        handleClose={() => setShowSuggestionModal(false)}
        initialProductName={productSearch}
      />
      {isOpenBarcodeScanner && (
        <BarcodeScannerModal
          isEnableGetProductDetails
          isOpen={isOpenBarcodeScanner}
          onClose={() => {
            setisOpenBarcodeScanner(false);
          }}
          onFetchProduct={(item) => {
            setScannedProductData(item);
          }}
          onProductNotFound={() => {
            setisOpenBarcodeScanner(false);
            setShowManualProductModal(true);
          }}
        />
      )}

      {showManualProductModal && (
        <ManualProductEntryModal
          show={showManualProductModal}
          onHide={() => setShowManualProductModal(false)}
          onSubmit={handleAddManualProduct}
        />
      )}

      {scannedProductData && (
        <ViewCustomerProduct
          show={scannedProductData ? true : false}
          handleSelectedData={handleSelectedData}
          onHide={() => setScannedProductData(null)}
          product_id={scannedProductData?.product_id}
          customerSelectedProducts={customerSelectedItem}
          selectedProductUnitId={scannedProductData?.selectedUnit?.unit_id}
        />
      )}
    </>
  );
}
